import React from "react";
import { Col, Input, Button, Menu, Dropdown } from "antd";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
import { TitleContainer } from "./elements";

interface TableTitleProps {
  setNameFilter: (value: string) => void;
  setShowCreateModal: (value: boolean) => void;
  setShowCreateGroupModal: (value: boolean) => void;
  setShowPriorityModal: (value: boolean) => void;
}

const TableTitle: React.FC<TableTitleProps> = ({
  setNameFilter,
  setShowCreateModal,
  setShowCreateGroupModal,
  setShowPriorityModal,
}) => {
  const menu = (
    <Menu>
      <Menu.Item key="order" onClick={() => setShowPriorityModal(true)}>
        Ordenar Grupos
      </Menu.Item>
      <Menu.Item key="create" onClick={() => setShowCreateGroupModal(true)}>
        Crear Grupo
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <TitleContainer>
        <Col
          span={24}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex",
            gap: "10px",
            flexGrow: 1 }}>
            <Input
              style={{ width: 250 }}
              placeholder="Buscar por nombre"
              allowClear
              onChange={(e) => setNameFilter(e.target.value)}
            />
          </div>
          <Dropdown overlay={menu} placement="bottomRight">
            <Button style={{ marginRight: 10 }} type="primary">
              Grupos <DownOutlined />
            </Button>
          </Dropdown>
          <div style={{ marginLeft: "auto" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setShowCreateModal(true)}
            >
              Crear Cupón
            </Button>
          </div>
        </Col>
      </TitleContainer>
    </div>
  );
};

export default TableTitle;
